export const downloadFileBinary = (blob: Blob, fileName?: string) => {
    const excelType =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    // If blob already has the correct type, use it as is, otherwise create a new one with correct type
    const finalBlob =
        blob.type === excelType ? blob : new Blob([blob], { type: excelType });

    // Create a temporary URL for the blob
    const downloadUrl = window.URL.createObjectURL(finalBlob);

    // Create an invisible anchor element and click it
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.target = '_blank';

    if (fileName) {
        link.download = fileName;
    }

    document.body.appendChild(link);
    link.click();

    // Cleanup: remove the link and revoke the URL to save memory
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);
};
